import { Phone, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AdvisorPanelMobileProps {
  name: string;
  phone: string;
}

const AdvisorPanelMobile = ({ name, phone }: AdvisorPanelMobileProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1">
      <span className="font-body text-[10px] font-semibold tracking-[1.5px] text-accent-primary">
        {t('chat.header.yourAdvisor')}
      </span>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <User size={14} className="text-foreground-secondary" />
          <span className="font-body text-[13px] font-medium text-foreground-primary">
            {name}
          </span>
        </div>
        <a
          href={`tel:${phone.replace(/-/g, '')}`}
          className="flex items-center gap-1.5 transition-colors hover:opacity-80"
        >
          <Phone size={12} className="text-accent-primary" />
          <span className="font-body text-[13px] font-medium text-accent-primary">
            {phone}
          </span>
        </a>
      </div>
    </div>
  );
};

export default AdvisorPanelMobile;
